import { Injectable } from "@angular/core";

// other services
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// models
import { Stream } from "../models/stream";

// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class StreamService {
    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(
        private http: HttpClient
    ) { }

    /**
     * get stream list by event
     *
     * @param eventId
     * @param limit
     * @param offset

     * @return {Observable<any>}
     */
    public getListByEvent(eventId: number, limit?: number, offset?: number): Observable<any> {
        let params = {
            limit: limit || 0,
            offset: offset || 0
        };

        return this.http.post(environment.api + '/event/' + eventId + '/stream', params);
    }

    /**
     * get by id
     *
     * @return {Observable<any>}
     */
    public getById(id: number): Observable<any> {
        return this.http.get(environment.api + '/stream/' + id);
    }
}
